export const DrawerTypes = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  DOCUMENT: 'DOCUMENT',
  FILE: 'FILE',
  AUDIO: 'AUDIO'
};
export const PickerTypes = {
  PANEL: 'PANEL',
  SIDE_MODAL: 'SIDE_MODAL'
};
export const PickerPanels = {
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  STOCK_IMAGES: 'STOCK_IMAGES',
  FOLDER: 'FOLDER',
  FROM_URL: 'FROM_URL',
  FILE_DETAIL: 'FILE_DETAIL',
  BULK_IMPORT_FROM_URL: 'BULK_IMPORT_FROM_URL',
  IMAGE_GENERATION: 'IMAGE_GENERATION',
  LANDING: 'LANDING'
};
export const IframeComponentTypes = {
  FILE_PICKER: 'FILE_PICKER',
  IMAGE_EDITOR: 'IMAGE_EDITOR'
};
export { FileTypes } from './fileTypes';
export const FMMessageType = 'FILE_MANAGER';
export const MessageActions = {
  IFRAME_READY: 'IFRAME_READY',
  OPEN_PICKER: 'OPEN_PICKER',
  OPEN_IMAGE_EDITOR: 'OPEN_IMAGE_EDITOR',
  OPEN_PICKER_COMPLETE: 'OPEN_PICKER_COMPLETE',
  CLOSE_PICKER: 'CLOSE_PICKER',
  ENTER_FULLSCREEN: 'ENTER_FULLSCREEN',
  EXIT_FULLSCREEN: 'EXIT_FULLSCREEN',
  UPLOAD_STARTED: 'UPLOAD_STARTED',
  UPLOAD_COMPLETE: 'UPLOAD_COMPLETE',
  CLOSE_PANEL: 'CLOSE_PANEL',
  SELECT_FILE: 'SELECT_FILE',
  SELECT_FILES: 'SELECT_FILES'
};
export const FileExtensionFilterTypes = {
  SUPPORTED: 'SUPPORTED',
  UNSUPPORTED: 'UNSUPPORTED',
  NONE: 'NONE'
};
export const PANEL_WIDTH = 590;
export const PANEL_WIDTH_EXPANDED = PANEL_WIDTH;
export const MIN_PICKER_WIDTH = 400;
export const MAX_PICKER_WIDTH = PANEL_WIDTH;
export { ThumbnailSizes } from './thumbnailSizes';
export const RequestStatus = {
  UNINITIALIZED: 'UNINITIALIZED',
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  NOTFOUND: 'NOTFOUND'
};
export const FILESIZE_UNITS = {
  B: 'B',
  KB: 'KB',
  MB: 'MB',
  GB: 'GB'
};
// we've historically used the modern convenience definition to display files sizes https://en.wikipedia.org/wiki/Megabyte#Definitions
export const BYTES_IN_MEGABYTE = 1000000;

// traditional size for megabytes
const BYTES_IN_MB_FOR_UPLOAD_LIMIT = 1024 * 1024;
// if a file is larger than this threshold, we'll use chunked uploads
export const LARGE_FILE_UPLOAD_SIZE_THRESHOLD = 100 * BYTES_IN_MB_FOR_UPLOAD_LIMIT;

// the size of each part of a large file upload
export const LARGE_FILE_UPLOAD_PART_SIZE = 20 * BYTES_IN_MB_FOR_UPLOAD_LIMIT;
export const LARGE_FILE_PART_UPLOAD_MAX_RETRIES = 3;
export const LARGE_FILE_PARALLEL_CHUNK_UPLOADS = 4;